export default "__VITE_ASSET__Ck_aKYt6__"